module.exports = __webpack_public_path__ + "img/1574156358.bc6b77f9.jpg";